import t from "./design-system.es906.js";
function i(e) {
  return Object.assign({}, t(), e);
}
export {
  i as default
};
//# sourceMappingURL=design-system.es893.js.map
